// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__ed7f95f5403b7d8bd2df{/*!*/}.AuthorHeader-cls2__c18e2e64ad6448e5c5ed{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__ed7f95f5403b7d8bd2df",
	"cls2": "AuthorHeader-cls2__c18e2e64ad6448e5c5ed AuthorHeader-cls1__ed7f95f5403b7d8bd2df"
};
export default ___CSS_LOADER_EXPORT___;
